import { render, staticRenderFns } from "./Pie3d.vue?vue&type=template&id=040f3c7a&scoped=true&"
import script from "./Pie3d.vue?vue&type=script&lang=js&"
export * from "./Pie3d.vue?vue&type=script&lang=js&"
import style0 from "./Pie3d.vue?vue&type=style&index=0&id=040f3c7a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040f3c7a",
  null
  
)

export default component.exports